import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  // compilePaginationObject,
} from 'app/utils/redux/helpers';
import { bankAccountSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
// import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/bankAccounts/actions';
import { BankAccountsActionTypes as types } from 'app/ducks/bankAccounts/types';

function* createBankAccountSaga(action): any {
  yield put(sagaActions.createBankAccountPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).organisationBankAccounts.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, bankAccountSchema);

    yield put(sagaActions.createBankAccountSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createBankAccountFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateBankAccountSaga(action): any {
  yield put(sagaActions.updateBankAccountPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).organisationBankAccounts.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, bankAccountSchema);

    yield put(sagaActions.updateBankAccountSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateBankAccountFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getBankAccountSaga(action): any {
  yield put(sagaActions.getBankAccountPending());
  const [error, response] = yield (yield TeammoApi(yield select())).organisationBankAccounts.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, bankAccountSchema);
    yield put(sagaActions.getBankAccountSuccess(normalizedResponse));
    return normalizedResponse.entities.bankAccounts[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getBankAccountFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

// function* getAllBankAccountsSaga(action): any {
//   yield put(
//     sagaActions.getAllBankAccountsPending(action.payload.compile ? action.payload.pagination : {}),
//   );
//   yield put(loadingStart());

//   const paginationObject = action.payload.compile
//     ? compilePaginationObject(yield select((state) => state.organisationBankAccounts.pagination))
//     : action.payload.pagination;

//   const [error, response] = yield (yield TeammoApi(yield select())).organisationBankAccounts.list(
//     paginationObject,
//   );

//   if (response) {
//     const normalizedResponse = normalize(response, bankAccountListSchema);

//     yield put(
//       sagaActions.getAllBankAccountsSuccess(normalizedResponse, response.meta),
//     );
//     yield put(loadingFinish());
//   } else {
//     yield put(
//       error,
//       sagaActions.getAllBankAccountsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
//     );
//   }
// }

/* ********************************* SAGA WATCHERS ********************************* */

function* createBankAccountSagaWatcher(): any {
  yield takeLatest(types.CREATE_BANK_ACCOUNT_REQUESTED, createBankAccountSaga);
}

function* updateBankAccountSagaWatcher(): any {
  yield takeLatest(types.UPDATE_BANK_ACCOUNT_REQUESTED, updateBankAccountSaga);
}

function* getBankAccountSagaWatcher(): any {
  yield takeEvery(types.GET_BANK_ACCOUNT_REQUESTED, getBankAccountSaga);
}

// function* getAllBankAccountsSagaWatcher(): any {
//   yield takeEvery(types.GET_ALL_BANK_ACCOUNTS_REQUESTED, getAllBankAccountsSaga);
// }

export default function* root(): any {
  yield all([
    createBankAccountSagaWatcher(),
    updateBankAccountSagaWatcher(),
    getBankAccountSagaWatcher(),
    // getAllBankAccountsSagaWatcher(),
  ]);
}
